import {
  FaBell,
  FaCheckCircle,
  FaClipboardList,
  FaClock,
  FaExclamationTriangle,
  FaShieldAlt,
  FaTimesCircle,
  FaUndo,
} from 'react-icons/fa';

export const REVIEW_STATUS = {
  PENDING_REVIEW: 'PENDING_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

/** Secure-mode check paid but waiting for admin review (before notification). */
export function isAwaitingManualReview(item) {
  if (!item) return false;
  if (item.reviewStatus === REVIEW_STATUS.PENDING_REVIEW) return true;
  if (item.reviewStatus === REVIEW_STATUS.REJECTED) return false;
  if (item.reviewStatus === REVIEW_STATUS.APPROVED) return false;
  return Boolean(
    item.secureMode
    && item.paymentStatus === 'PAID'
    && item.verificationStatus === 'PAID'
  );
}

export function canAdminReview(item) {
  return isAwaitingManualReview(item);
}

export function getVerificationStatusMeta(item) {
  if (item.reviewStatus === REVIEW_STATUS.REJECTED) {
    return { label: 'Rejected', className: 'status-rejected', icon: FaTimesCircle };
  }
  if (isAwaitingManualReview(item)) {
    return { label: 'Awaiting manual review', className: 'status-review-pending', icon: FaShieldAlt };
  }
  if (item.verificationStatus === 'FAILED') {
    return { label: 'Failed', className: 'status-failed', icon: FaTimesCircle };
  }
  if (item.paymentStatus === 'REFUNDED') {
    return { label: 'Refunded', className: 'status-refunded', icon: FaUndo };
  }
  if (item.verificationStatus === 'NOTIFIED') {
    return { label: 'Notification sent', className: 'status-notified', icon: FaBell };
  }
  if (item.paymentStatus === 'PAID' && item.verificationStatus === 'PAID') {
    return { label: 'Pending notification', className: 'status-pending', icon: FaClock };
  }
  if (item.paymentStatus === 'PAID') {
    return { label: 'Paid', className: 'status-paid', icon: FaCheckCircle };
  }
  if (item.paymentStatus === 'UNPAID') {
    return { label: 'Unpaid', className: 'status-unpaid', icon: FaExclamationTriangle };
  }
  return { label: item.paymentStatus || 'Unknown', className: 'status-default', icon: FaClipboardList };
}

export function buildManualReviewResult(message) {
  return {
    reviewPending: true,
    overallSuccess: true,
    emailStatus: 'PENDING',
    smsStatus: 'NOT_APPLICABLE',
    emailMessage:
      message
      || 'Your request has been submitted for manual verification. KeepMyAsset will review it and email the requester with the outcome.',
    smsMessage: 'SMS notifications are not enabled yet.',
  };
}
